import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserIdleService } from 'angular-user-idle';

import { AuthenticationService, CompanyService, SessionTabSyncService } from './_services';
import { BaseComponent } from './_components/base.component';
import { persistGotoForLogin } from './_utils/helpers';

@Component({
  selector: 'app-user-idle-modal',
  templateUrl: './user-idle-modal.component.html',
})
export class UserIdleModalComponent extends BaseComponent implements OnInit, OnDestroy {
  idle!: number;
  timeout!: number;
  secondsRemaining = 0;
  private logoutDeadlineMs = 0;
  private tick: ReturnType<typeof setInterval> | null = null;
  private loggingOut = false;

  constructor(
    router: Router,
    authenticationService: AuthenticationService,
    companyService: CompanyService,
    public bsModalRef: BsModalRef,
    private userIdleService: UserIdleService,
    private sessionTabSync: SessionTabSyncService,
    private ngZone: NgZone,
  ) {
    super(router, authenticationService, companyService);
  }

  ngOnInit() {
    // Own the countdown here instead of angular-user-idle's onTimeout(), which
    // stopTimer()/resetTimer() calls elsewhere can cancel while this modal is open.
    this.userIdleService.stopTimer();
    this.secondsRemaining = this.timeout || 0;
    this.logoutDeadlineMs = Date.now() + this.secondsRemaining * 1000;
    this.ngZone.run(() => this.updateCountdown());
    this.tick = setInterval(() => this.ngZone.run(() => this.updateCountdown()), 1000);
  }

  ngOnDestroy() {
    if (this.tick) {
      clearInterval(this.tick);
      this.tick = null;
    }
  }

  get displayTime(): string {
    const m = Math.floor(this.secondsRemaining / 60);
    const s = this.secondsRemaining % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  }

  onCancel() {
    this.userIdleService.stopTimer();
    this.userIdleService.resetTimer();
    this.sessionTabSync.notifyIdleReset();
    this.bsModalRef.hide();
  }

  private updateCountdown() {
    this.secondsRemaining = Math.max(0, Math.ceil((this.logoutDeadlineMs - Date.now()) / 1000));
    if (this.secondsRemaining <= 0) {
      if (this.tick) {
        clearInterval(this.tick);
        this.tick = null;
      }
      this.onForceLogout();
    }
  }

  private onForceLogout() {
    if (this.loggingOut) {
      return;
    }
    this.loggingOut = true;
    if (this.tick) {
      clearInterval(this.tick);
      this.tick = null;
    }
    // AppComponent handles the actual logout for every tab (including this one).
    this.sessionTabSync.notifyIdleLogout();
  }
}
